import { useState } from 'react';

const NAV = [
  { label: '实时进展', href: '#live' },
  { label: '热点直击', href: '#feed' },
  { label: '辟谣实锤对照', href: '#compare' },
  { label: '专题合集', href: '#collection' },
  { label: '反转热度榜', href: '#rank' },
  { label: '当事人回应', href: '#timeline' },
];

export default function StickyHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="抖阴黑料 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-empathize-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-wide text-foreground-950 md:text-xl">抖阴黑料</span>
            <span className="mt-1 text-[11px] text-foreground-500">辟谣 · 反转 · 真相追踪</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="cursor-pointer whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2.5 lg:flex">
          <button
            type="button"
            aria-label="搜索"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:border-background-300 hover:bg-background-100"
          >
            <i className="ri-search-line text-base" />
          </button>
          <a
            href="#subscribe"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-notification-3-line text-base" />
            吃瓜订阅
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-200 text-foreground-700 lg:hidden"
        >
          <i className={open ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动导航">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
              >
                {n.label}
              </a>
            ))}
            <div className="mt-2 flex gap-2">
              <button
                type="button"
                className="flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 py-2.5 text-sm font-medium text-foreground-700"
              >
                <i className="ri-search-line" /> 搜索
              </button>
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 py-2.5 text-sm font-semibold text-background-50"
              >
                <i className="ri-notification-3-line" /> 吃瓜订阅
              </a>
            </div>
          </nav>
        </div>
      ) : null}
    </header>
  );
}